import { useMemo } from 'react'
import { useModelStore } from '@editorStores'

export interface FilterState {
  showExternalWalls: boolean
  showInternalWalls: boolean
  showBeams: boolean
  showColumns: boolean
  showPurlins: boolean
  showSlabs: boolean
  showRoofSlabs: boolean
  showVerticalSlabs: boolean
  showVerticalRoofSlabs: boolean
  showSlabBeams: boolean
  showRoofSlabBeams: boolean
  showRips: boolean
  showLintels: boolean
  showFoundation: boolean
  showComments: boolean
  showWallOpenings: boolean
  showVerticalOpeningAlignmentHelpers: boolean

  positionVisibilityFollowsWallVisibility: boolean
  slabPositionVisibilityFollowsSlabVisibility: boolean
  roofSlabPositionVisibilityFollowsRoofSlabVisibility: boolean
}

export const useFilterState = () => {
  const typeVisibility = useModelStore(state => state.visibilityByType)
  const positionVisibilityFollowsWallVisibility = useModelStore(
    state => state.positionVisibilityFollowsWallVisibility,
  )
  const slabPositionVisibilityFollowsSlabVisibility = useModelStore(
    state => state.slabPositionVisibilityFollowsSlabVisibility,
  )
  const roofSlabPositionVisibilityFollowsRoofSlabVisibility = useModelStore(
    state => state.roofSlabPositionVisibilityFollowsRoofSlabVisibility,
  )
  const showComments = useModelStore(state => state.showComments)
  const showWallOpenings = useModelStore(state => state.showWallOpenings)
  const showVerticalOpeningAlignmentHelpers = useModelStore(
    state => state.showVerticalOpeningAlignmentHelpers,
  )
  return useMemo(() => {
    const filterState = {
      showExternalWalls: typeVisibility.outer_walls,
      showInternalWalls: typeVisibility.inner_walls,
      showBeams: typeVisibility.beams,
      showColumns: typeVisibility.columns,
      showPurlins: typeVisibility.purlins,
      showSlabs: typeVisibility.slabs,
      showRoofSlabs: typeVisibility.roof_slabs,
      showVerticalSlabs: typeVisibility.vertical_slabs,
      showVerticalRoofSlabs: typeVisibility.vertical_roof_slabs,
      showSlabBeams: typeVisibility.slab_beams,
      showRoofSlabBeams: typeVisibility.roof_slab_beams,
      showRips: typeVisibility.rips,
      showLintels: typeVisibility.lintels,
      showFoundation: typeVisibility.foundation,
      showComments: showComments,
      showWallOpenings: showWallOpenings,
      showVerticalOpeningAlignmentHelpers: showVerticalOpeningAlignmentHelpers,
      positionVisibilityFollowsWallVisibility: positionVisibilityFollowsWallVisibility,
      slabPositionVisibilityFollowsSlabVisibility: slabPositionVisibilityFollowsSlabVisibility,
      roofSlabPositionVisibilityFollowsRoofSlabVisibility:
        roofSlabPositionVisibilityFollowsRoofSlabVisibility,
    } as FilterState
    return filterState
  }, [
    typeVisibility,
    positionVisibilityFollowsWallVisibility,
    slabPositionVisibilityFollowsSlabVisibility,
    roofSlabPositionVisibilityFollowsRoofSlabVisibility,
    showComments,
    showWallOpenings,
    showVerticalOpeningAlignmentHelpers,
  ])
}
